import styled from "styled-components";

const ContainerAccordion = styled.div`

    margin-bottom: 7px;

    .MuiButtonBase-root{
        height: 100%;
    }

    .accordion-program{
        .accordion-program-title{
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            word-break: break-word;
            display: -webkit-box;
        }
        .MuiAccordionDetails-root{
            padding:10px;
            padding-right: 0px;
        }

        .MuiCollapse-wrapper{
            border:none;
        }
    }

    .accordion-project{
        width: 100%;
        box-shadow: none;

        .MuiCollapse-wrapper{
            border:none;
        }

        .MuiAccordion-root{
            box-shadow: none;
        }

        .MuiButtonBase-root{
            min-height: 52px;
            height: fit-content;
        }

        .MuiButtonBase-root.MuiAccordionSummary-root{
            background: var(--accordion-color);
        }

        .list-component-child{
            background: transparent !important;
            background-color: transparent !important;
            border: none;
            box-shadow: none;

            div{
                overflow: visible !important;
            }
        }

        .list-component-child:hover{
            background: transparent !important;
            background-color: transparent !important;
            border: none;
            box-shadow: none !important;
        }

        .ccxyYC{
            margin: 0px;
        }
    }

    .accordion-phase{
        width: 100%;

        .MuiCollapse-wrapper{
            border:none;
        }

        .isxWuD:hover.li.list-component-child:hover{
            box-shadow: none;
        }

        .MuiButtonBase-root.MuiAccordionSummary-root{
            background: #9e9e9e14;
        }

        .MuiAccordionDetails-root{
            .MuiCollapse-wrapper{
                padding: 0px 10px 0px 10px;
            }
        }
    }

    .container-actions{
        width: 100%;
        .list-component-child{
            height: 100%;
            border-bottom: 1px solid var(--border-color);
            box-shadow: 0 2px 1px -1px var(--border-color);
        }

        .list-component-child:hover{
            height: 100%;
            border-bottom: 1px solid var(--border-color);
            box-shadow: 0 2px 1px -1px var(--border-color);
        }
    }

    ul.ul-project-head{
        width: 100%;
    }

    li.project-head{
        display:flex;
        justify-content: space-between;
        width: 100%;
        border-bottom: 1px solid var(--border-color);
        background: var(--input-background-color);
        color: var(--default-color-font);
        padding: 4px;
        margin: 5px 0;
        font-size: 0.9rem;
        font-weight: bold;

        @media(max-width: 600px){
            display: none;
        }     
        
        small{
            font-size: 0.75rem;
        }
    }

    .head-title{
        display: block;

        @media(max-width: 971px){
            background-color: blue;
            display: none;
        }
    }

    div._component-popover{
		border: 1px solid var(--border-color);
	}
`;

export default ContainerAccordion;
